import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import _ from "lodash";
import moment from "moment";
import { DatePicker, Popconfirm } from "antd";
import { Button } from "react-bootstrap";
import exportFromBlob from "helpers/export-from-blob";
import sortObject from "functions/sort-object";
import UserTypes from "components/auth/user-types";
// import getColumnWidth from "helpers/getColumnWidthReactTable";
import SearchSelect from "components/common/SearchSelect";
import Spinner from "components/common/Spinner";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import MainChart from "components/menu/summary/main-chart";
import { convert24To12, convertFloatToTime } from "helpers/timeStringToFloat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    openCustomModal,
    closeCustomModal
} from "components/custom/modals";
import {
    fetchSummary,
    fetchSummaryJobs,
    fetchReportRanges,
    clearSummary,
    fetchExportExcel,
    fetchExportCSV,
    updateReleaseSingle,
    updateReleaseAll,
    updateDisplayChartToClient,
    updateReviewed,
    updateReviewed2,
    updateReleaseNotes
} from "api/menu/summary/actions";

const Incomplete = React.lazy(() =>
    import("components/menu/summary/modals/incomplete"));
const Exceptions = React.lazy(() =>
    import("components/menu/summary/modals/exceptions"));
const Flagged = React.lazy(() =>
    import("components/menu/summary/modals/flagged"));
const ReleaseNotesModal = React.lazy(() =>
    import("components/menu/summary/modals/release-notes-modal"));
const ServiceReport = React.lazy(() =>
    import("components/menu/reporting/service-report"));

const { RangePicker } = DatePicker;

class SummaryMain extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.reactTable = React.createRef();

        this.state = {
            summaryList: {},
            jobsOptions: [],
            dateRangeOptions: [],

            selectedJob: null,
            selectedDateRange: null,

            filteredIdArr: [],

            displayExecutiveSummary: false
        };

        this.onFilteredChange = this.onFilteredChange.bind(this);

        this.handleSelect = this.handleSelect.bind(this);
        this.handleReleaseSingle = this.handleReleaseSingle.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.handleReleaseAll = this.handleReleaseAll.bind(this);
        this.handleExportExcel = this.handleExportExcel.bind(this);
        this.handleExportCSV = this.handleExportCSV.bind(this);
        this.handleChangeDisplayChart = this.handleChangeDisplayChart.bind(this);
        this.handleReviewedInternal = this.handleReviewedInternal.bind(this);

        this.handleFlagged = this.handleFlagged.bind(this);
        this.handleExceptions = this.handleExceptions.bind(this);
        this.handleIncomplete = this.handleIncomplete.bind(this);
        this.handleServiceReport = this.handleServiceReport.bind(this);
        this.openReleaseNotes = this.openReleaseNotes.bind(this);
        this.handleReleaseNotes = this.handleReleaseNotes.bind(this);

        this.props.fetchSummaryJobs();
    }

    componentWillReceiveProps(nextProps) {
        const newStates = {};

        if (!_.isEqual(nextProps.summaryList, this.state.summaryList)) {
            if (nextProps.summaryList.details) {
                newStates.filteredIdArr =
                    nextProps.summaryList.details
                        .filter(original => !original.released)
                        .map(original => original.serviceID);
                newStates.summaryList = nextProps.summaryList;
            }
        }

        if (!_.isEqual(nextProps.summaryJobs, this.props.summaryJobs) ||
            !this.state.jobsOptions.length) {
            newStates.jobsOptions = [];
            sortObject(
                nextProps.summaryJobs,
                Object.keys(nextProps.summaryJobs).map((value) => parseInt(value, 10)),
                "jobNumber",
                true
            ).forEach((index) => {
                newStates.jobsOptions.push({
                    value: nextProps.summaryJobs[index].id,
                    label: `${nextProps.summaryJobs[index].jobNumber} - ${nextProps.summaryJobs[index].description}`
                });
            });
        }
        if (!_.isEqual(nextProps.summaryRanges, this.props.summaryRanges) ||
            !this.state.dateRangeOptions.length) {
            newStates.dateRangeOptions = [];
            nextProps.summaryRanges.forEach(value => {
                newStates.dateRangeOptions.push({
                    value: value.reportId,
                    label: value.dateRange
                });
            });
        }

        if (Object.keys(newStates).length) {
            this.setState(newStates);
        }
    }

    componentWillUnmount() {
        this.props.clearSummary();
    }

/*
    timeToUSStandard = (time) => {
        let AMPM = "AM";
        if (time > 12) {
            time -= 12;
            AMPM = "PM";
        }
        return `${convertFloatToTime(time)} ${AMPM}`;
    };
*/

    onFilteredChange = () => {
        const current = this.reactTable.current;
        if (current) {
            const filteredIdArr = current
                .getResolvedState()
                .sortedData.map(item => item._original.serviceID);

            this.setState({
                filteredIdArr
            });
        }
    };

    handleSelect = (name, option) => {
        const newState = {};
        newState[name] = option;
        newState.filteredIdArr = [];

        if (option) {
            if (name === "selectedJob") {
                this.props.fetchReportRanges(option.value);
                newState.selectedDateRange = null;
            }

            if (name === "selectedDateRange" && this.state.selectedJob) {
                this.props.fetchSummary(this.state.selectedJob.value, option.value);
            }
        }

        this.setState(newState);
    };

    handleReviewedInternal = (key, serviceId, value) => {
        const callback = () => {
            const summaryList = Object.assign({}, this.state.summaryList);
            if (summaryList.details) {
                summaryList.details = Object.assign([], summaryList.details);
                summaryList.details = summaryList.details.map(original => {
                    if (serviceId === original.serviceID) {
                        original[key] = value;
                    }
                    return original;
                });

                this.setState({
                    summaryList
                });
            }
        };
        if (key === "reviewedClient2") {
            this.props.updateReviewed2(serviceId, value, callback);
        } else {
            this.props.updateReviewed(serviceId, value, callback);
        }
    };

    handleChangeDisplayChart = (status) => {
        const summaryList = Object.assign({}, this.state.summaryList);
        if (summaryList && summaryList.reportId) {
            this.props.updateDisplayChartToClient(summaryList.reportId, status, () => {
                summaryList.displayCompletionChartToClient = status;
                this.setState({
                    summaryList
                });
            });
        }
    };

    getColumns = () => {
        const { user } = this.props;
        const { summaryList } = this.state;
        const resultCount = summaryList && summaryList.details ? summaryList.details.length : 0;

        const isCustomer = user && user.role &&
            user.role.includes(UserTypes.customer);

        let result = [];

        if (!isCustomer) {
            result.push({
                id: "reviewedInternal",
                Header: "Reviewed",
                accessor: original => (original.reviewedInternal ? "Yes" : "No"),
                Cell: ({ original }) => (
                    <div className="custom-control custom-checkbox">
                        <input
                            id={`reviewedInternal-${original.serviceID}`}
                            type="checkbox"
                            checked={original.reviewedInternal}
                            onChange={() => this.handleReviewedInternal(
                                "reviewedInternal",
                                original.serviceID,
                                !original.reviewedInternal
                            )}
                            className="custom-control-input"
                        />
                        <label
                            className="custom-control-label"
                            htmlFor={`reviewedInternal-${original.serviceID}`}
                        >
                            {original.reviewedInternal ? "Yes" : "No"}
                        </label>
                    </div>
                ),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                ),
                width: 65
            });
            result.push({
                id: "released",
                Header: "Released",
                accessor: original => (original.released ? "Yes" : "No"),
                Cell: ({ original }) => (
                    <div className="custom-control custom-checkbox">
                        <input
                            id={`released-${original.serviceID}`}
                            type="checkbox"
                            checked={original.released}
                            onChange={() =>
                                this.handleReleaseSingle(original.serviceID, !original.released)}
                            className="custom-control-input"
                        />
                        <label
                            className="custom-control-label"
                            htmlFor={`released-${original.serviceID}`}
                        >
                            {original.released ? "Yes" : "No"}
                        </label>
                    </div>
                ),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                ),
                width: 75
            });
        } else {
            result.push({
                id: "reviewedClient",
                Header: "Reviewed",
                accessor: original => (original.reviewedClient ? "Yes" : "No"),
                Cell: ({ original }) => (
                    <div className="form-check">
                        <input
                            type="checkbox"
                            checked={original.reviewedClient}
                            className="form-check-input"
                            onChange={() => this.handleReviewedInternal(
                                "reviewedClient",
                                original.serviceID,
                                !original.reviewedClient
                            )}
                            disabled={false}
                            readOnly={false}
                        />
                        <label className="form-check-label">
                            {original.reviewedClient ? "Yes" : "No"}
                        </label>
                    </div>
                ),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                ),
                width: 65
            });
            result.push({
                id: "reviewedClient2",
                Header: "Reviewed 2",
                accessor: original => (original.reviewedClient2 ? "Yes" : "No"),
                Cell: ({ original }) => (
                    <div className="form-check">
                        <input
                            type="checkbox"
                            checked={original.reviewedClient2}
                            className="form-check-input"
                            onChange={() => this.handleReviewedInternal(
                                "reviewedClient2",
                                original.serviceID,
                                !original.reviewedClient2
                            )}
                        />
                        <label className="form-check-label">
                            {original.reviewedClient2 ? "Yes" : "No"}
                        </label>
                    </div>
                ),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                ),
                width: 75
            });
        }

        if (!isCustomer) {
            result.push({
                id: "releaseNotes",
                Header: "Released Notes",
                accessor: "releaseNotes",
                Cell: ({ original }) => (
                    <div className="release-notes-wrapper">
                        {original.releaseNotes}
                        <div className="text-right mt-1">
                            <button className="btn btn-primary btn-sm" onClick={() => this.openReleaseNotes(original.serviceID, original.releaseNotes)}>
                                <FontAwesomeIcon icon="pen" title="Update" />
                            </button>
                        </div>
                    </div>
                )
            });
        }

        result.push({
            id: "storeName",
            Header: "Store Location",
            accessor: "storeName",
            // width: 80
        });
        result.push({
            id: "storeNumber",
            Header: "Store #",
            accessor: "storeNumber",
            filterMethod: (filter, row) => {
                if (!filter.value) {
                    return true;
                }
                return filter.value.toString() === row._original.storeNumber.toString();
            },
            Cell: ({ original }) => {
                const role = this.props.user.role;
                let backgroundColor = "transparent";
                if (!isCustomer) {
                    if (original.released) {
                        backgroundColor = "#add8e6";
                    } else if (original.reviewedInternal) {
                        backgroundColor = "#90ee90";
                    }
                } else if (isCustomer) {
                    if (original.reviewedClient2 === true) {
                        backgroundColor = "#add8e6";
                    } else if (original.reviewedClient === true) {
                        backgroundColor = "#90ee90";
                    }
                }
                return (
                    <div
                        className="h-100 w-100 d-flex justify-content-center align-items-start"
                        style={{
                            backgroundColor
                        }}
                    >
                        {
                            role.includes(UserTypes.customer)
                                ? original.storeNumber
                                : (
                                    <button
                                        className="btn  btn-link"
                                        onClick={() => this.handleServiceReport(original.serviceID)}
                                    >
                                        {original.storeNumber}
                                    </button>
                                )
                        }
                    </div>
                );
            },
            width: 80,
            className: "store-number"
        });
        // if (!isCustomer) {
            result.push({
                id: "trait",
                Header: "Trait",
                accessor: "trait",
                // width: 80
            });
        // }
        result.push({
            id: "completedDate",
            Header: "Service Date",
            width: 160,
            className: "text-center",
            headerClassName: "text-center",
            accessor: original => moment(original.completedDate).format(this.dateFormat),
            /*
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    format={this.dateFormat}
                    value={filter && filter.value ? moment(filter.value) : null}
                    onChange={date => onChange(date || null)}
                    allowClear={true}
                />
            ),
            */
            filterMethod: (filter, row) => {
                const completedDate = row.completedDate
                    ? moment(row.completedDate).valueOf()
                    : null;
                const fromDate = filter && filter.value && filter.value[0]
                    ? moment(filter.value[0]).valueOf()
                    : null;
                const toDate = filter && filter.value && filter.value[1]
                    ? moment(filter.value[1]).valueOf()
                    : null;
                if (!fromDate && !toDate) {
                    return true;
                } else if (
                    fromDate &&
                    toDate &&
                    completedDate >= fromDate &&
                    completedDate <= toDate
                ) {
                    return true;
                }
                return false;
            },
            Filter: ({ filter, onChange }) => {
                const fromDate = filter && filter.value && filter.value[0] ? filter.value[0] : null,
                    toDate = filter && filter.value && filter.value[1] ? filter.value[1] : null;
                return (
                    <RangePicker
                        format={this.dateFormat}
                        value={[
                            fromDate,
                            toDate
                        ]}
                        onChange={date => onChange(date || null)}
                        allowClear={true}
                    />
                );
            },
        });

        if (!isCustomer) {
            result.push({
                id: "merchandiser",
                Header: "Merchandiser",
                accessor: "merchandiser",
            });
            result.push({
                id: "timeIn",
                Header: "Time In",
                // accessor: "timeIn",
                className: "text-center",
                accessor: original => convert24To12(convertFloatToTime(original.timeIn)),
                Cell: ({ original }) => convert24To12(convertFloatToTime(original.timeIn)),
                width: 60
            });
            result.push({
                id: "timeOut",
                Header: "Time Out",
                // accessor: "timeOut",
                className: "text-center",
                accessor: original => convert24To12(convertFloatToTime(original.timeOut)),
                Cell: ({ original }) => convert24To12(convertFloatToTime(original.timeOut)),
                width: 60
            });
            result.push({
                id: "comments",
                Header: "Comments",
                accessor: "comments",
            });
        }

        result.push({
            id: "clientComments",
            Header: summaryList.clientCommentsLabel ? summaryList.clientCommentsLabel : "Client Comments",
            accessor: "clientComments",
        });
        result.push({
            id: "pictures",
            Header: "Pictures",
            Cell: ({ original }) => (
                <a
                    target="_blank"
                    href={original.picturesUrl}
                >
                    View Pictures
                </a>
            ),
            Filter: () => false,
            width: 80
        });

        if (summaryList && summaryList.headers) {
            summaryList.headers.forEach(perQuestion => {
                result.push({
                    id: `question${perQuestion.id}`,
                    Header: perQuestion.text,
                    accessor: original => (original.answers[perQuestion.id]
                        ? original.answers[perQuestion.id].comments
                        : ""
                    ),
                    className: "h-100 text-center",
                    Cell: ({ original }) => (original.answers[perQuestion.id] ?
                        (
                            <div className={`h-100 ${original.answers[perQuestion.id].flagged ? "bg-warning" : ""}`}>
                                <div className="mb-1">{original.answers[perQuestion.id].textValue}</div>
                                {original.answers[perQuestion.id].comments ?
                                    <div>
                                        <div><b>Comments:</b></div>
                                        <div>{original.answers[perQuestion.id].comments}</div>
                                    </div>
                                    : null}
                            </div>
                        )
                        : ""
                    ),
                    filterMethod: (filter, row) => {
                        const answer = row._original
                            && row._original.answers
                            && row._original.answers[perQuestion.id]
                            && row._original.answers[perQuestion.id].textValue
                                ? row._original.answers[perQuestion.id].textValue
                                : "";
                        return (answer.toLowerCase().includes(filter.value));
                    }
                });
            });
        }

        if (!resultCount) {
            return result;
        }

        result = result.map((value) => {
            value.headerClassName = "text-left";
            value.style = { whiteSpace: "unset" };
            value.headerStyle = { whiteSpace: "unset" };
            /*
            value.width = getColumnWidth(
                summaryList.details,
                value.accessor,
                value.Header
            );
            */
            /*
            if (!value.id.includes("question")) {
                value.width = getColumnWidth(
                    summaryList.details,
                    value.accessor,
                    value.Header
                );
            }
            */
            return value;
        });

        return result;
    };

    handleFlagged = () => {
        const { summaryList } = this.state;

        const modalObj = {
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)",
                    maxWidth: 800
                },
            },
            header: "Flagged",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <Flagged
                        reportId={summaryList.reportId}
                        totalServices={summaryList.details
                            ? summaryList.details.length
                            : 0}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleExceptions = () => {
        const { summaryList } = this.state;

        const modalObj = {
            id: "show-exceptions",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: "Show Exceptions",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <Exceptions
                        jobId={summaryList.jobId}
                        reportId={summaryList.reportId}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleIncomplete = () => {
        const {
            summaryList
        } = this.props;

        const modalObj = {
            id: "show-incomplete",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: "Show Incomplete",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <Incomplete
                        jobId={summaryList.jobId}
                        reportId={summaryList.reportId}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleServiceReport = (serviceId) => {
        const modalObj = {
            id: "view-report",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "calc(100% - 40px)"
                },
            },
            header: `Service Report: ${serviceId}`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ServiceReport
                        serviceId={serviceId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => {
                            this.props.closeCustomModal(modalObj);
                            this.props.fetchSummary(
                                this.state.selectedJob.value,
                                this.state.selectedDateRange.value
                            );
                        }}
                        onSubmit={() => {
                            this.props.closeCustomModal(modalObj);
                            this.props.fetchSummary(
                                this.state.selectedJob.value,
                                this.state.selectedDateRange.value
                            );
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleReleaseSingle = (serviceId, value) => {
        this.props.updateReleaseSingle(serviceId, value, () => {
            const summaryList = Object.assign({}, this.state.summaryList);
            if (summaryList.details) {
                summaryList.details = Object.assign([], summaryList.details);
                summaryList.details = summaryList.details.map(original => {
                    if (serviceId === original.serviceID) {
                        original.released = value;
                    }
                    return original;
                });

                this.setState({
                    summaryList
                });
            }
        });
    };

    handleReleaseAll = () => {
        const { filteredIdArr } = this.state;
        this.props.updateReleaseAll(filteredIdArr, () => {
            const summaryList = Object.assign({}, this.state.summaryList);
            if (summaryList.details) {
                summaryList.details = Object.assign([], summaryList.details);
                summaryList.details = summaryList.details.map(original => {
                    if (filteredIdArr.indexOf(original.serviceID) > -1) {
                        original.released = true;
                    }
                    return original;
                });

                this.setState({
                    summaryList
                });
            }
        });
    };

    handleExportExcel = () => {
        const {
            summaryList
        } = this.state;

        this.props.fetchExportExcel(summaryList.jobId, summaryList.reportId, data => {
            const fileName = `summary-${moment().format("YYYY-MM-DD-HH-mm")}.xlsx`;
            exportFromBlob(data, fileName);
        });
    };

    handleExportCSV = () => {
        const {
            summaryList
        } = this.state;

        this.props.fetchExportCSV(summaryList.jobId, summaryList.reportId, data => {
            const fileName = `summary-${moment().format("YYYY-MM-DD-HH-mm")}.csv`;
            exportFromBlob(data, fileName);
        });
    };

    openReleaseNotes = (serviceId, releaseNotes) => {
        const modalObj = {
            id: "release-notes",
            modalSettings: {
                size: "sm",
            },
            header: "Edit Release Notes",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ReleaseNotesModal
                        value={releaseNotes || ""}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={(value) => {
                            this.props.closeCustomModal(modalObj);
                            this.props.updateReleaseNotes(serviceId, value, () => {
                                this.handleReleaseNotes(serviceId, value);
                            });
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleReleaseNotes = (serviceId, value) => {
        const summaryList = Object.assign({}, this.state.summaryList);
        if (summaryList.details) {
            summaryList.details = Object.assign([], summaryList.details);
            summaryList.details = summaryList.details.map(original => {
                if (original.serviceID === serviceId) {
                    original.releaseNotes = value;
                }
                return original;
            });

            this.setState({
                summaryList
            });
        }
    };

    render() {
        const { loading } = this.props;
        const {
            summaryList,
            jobsOptions,
            dateRangeOptions,

            selectedJob,
            selectedDateRange,

            filteredIdArr,

            displayExecutiveSummary
        } = this.state;

        const resultCount = summaryList && summaryList.details ? summaryList.details.length : 0;
        const pageSize = Math.max(20, resultCount);
        const exceptionsCount = typeof summaryList.totalExceptions !== "undefined" ? summaryList.totalExceptions : 0;
        const incompleteCount = typeof summaryList.totalIncomplete !== "undefined" ? summaryList.totalIncomplete : 0;
        const flaggedCount = typeof summaryList.totalFlagged !== "undefined" ? summaryList.totalFlagged : 0;

        const chartData = [{
            name: "Incomplete",
            value: incompleteCount
        }, {
            name: "Complete",
            value: resultCount
        }];

        const reviewedCounts = {
            reviewed: 0,
            notReviewed: 0
        };
        if (summaryList && summaryList.details && Array.isArray(summaryList.details)) {
            summaryList.details.forEach(value => {
                if (value.reviewedInternal) {
                    reviewedCounts.reviewed += 1;
                } else {
                    reviewedCounts.notReviewed += 1;
                }
            });
        }

        const reviewedChartData = [{
            name: "Reviewed",
            value: reviewedCounts.reviewed
        }, {
            name: "Not Reviewed",
            value: reviewedCounts.notReviewed
        }];

        const isCustomer = this.props.user.role.includes(UserTypes.customer);
        let showChart = false;
        if (typeof summaryList.displayCompletionChartToClient !== "undefined") {
            showChart = true;
            if (isCustomer) {
                showChart = summaryList.displayCompletionChartToClient;
            }
        }

        let data = resultCount ? summaryList.details : [];
        if (displayExecutiveSummary && summaryList.headers) {
            data = data.filter(item => {
                // eslint-disable-next-line guard-for-in,no-restricted-syntax
                for (const index in summaryList.headers) {
                    const perQuestion = summaryList.headers[index];
                    if (item.answers
                        && item.answers[perQuestion.id]
                        && item.answers[perQuestion.id].flagged
                    ) {
                        return true;
                    }
                }
                return false;
            });
        }

        return (
            <div className="dashboard">
                <div className="row">
                    <div className="col-2 col-xs-12">
                        <div className="form-group">
                            <label>Job:</label>
                            <SearchSelect
                                className="custom-react-select"
                                options={jobsOptions}
                                isLoading={loading}
                                isClearable={false}
                                isSearchable={true}
                                onChange={(option) => this.handleSelect("selectedJob", option)}
                                value={selectedJob}
                            />
                        </div>
                        <div className="form-group">
                            <label>Date Range:</label>
                            <SearchSelect
                                className="custom-react-select"
                                options={dateRangeOptions}
                                isLoading={loading}
                                isClearable={false}
                                isSearchable={true}
                                onChange={(option) => this.handleSelect("selectedDateRange", option)}
                                value={selectedDateRange}
                                isDisabled={selectedJob === null}
                            />
                        </div>
                    </div>
                    <div className="col-3 col-xs-12">
                        {!showChart ||
                            <MainChart
                                data={chartData}
                                isChecked={!!summaryList.displayCompletionChartToClient}
                                onChange={this.handleChangeDisplayChart}
                            />
                        }
                    </div>
                    <div className="col-3 col-xs-12">
                        {!showChart ||
                            <MainChart
                                data={reviewedChartData}
                                showActions={false}
                                colors={["#28a745", "#dc3545"]}
                            />
                        }
                    </div>
                    <div className="col-4 col-xs-12">
                        <div className="h-100 d-flex flex-wrap justify-content-center align-items-center flex-column">
                            <div className="d-flex">
                                <button
                                    className="btn btn-warning btn-sm m-2"
                                    onClick={this.handleFlagged}
                                    disabled={!summaryList || !summaryList.totalFlagged}
                                >
                                    Flagged ({flaggedCount})
                                </button>
                                {isCustomer ||
                                <button
                                    className="btn btn-primary btn-sm m-2"
                                    onClick={this.handleExceptions}
                                    disabled={!exceptionsCount}
                                >
                                    Show Exceptions ({exceptionsCount})
                                </button>
                                }
                                {isCustomer ||
                                <button
                                    className="btn btn-primary btn-sm m-2"
                                    onClick={this.handleIncomplete}
                                    disabled={!incompleteCount}
                                >
                                    Show Incomplete Services ({incompleteCount})
                                </button>
                                }
                            </div>
                            <div className="d-flex">
                                {isCustomer ||
                                    <Popconfirm
                                        title={`Are you sure you want release ${filteredIdArr.length} services?`}
                                        onConfirm={this.handleReleaseAll}
                                        placement="bottom"
                                        okText="Yes"
                                        cancelText="Cancel"
                                    >
                                        <Button
                                            variant="primary m-2"
                                            disabled={!resultCount || !filteredIdArr.length}
                                        >
                                            Release All
                                        </Button>
                                    </Popconfirm>
                                }
                                <button
                                    className="btn btn-primary m-2"
                                    disabled={!resultCount}
                                    onClick={this.handleExportExcel}
                                >
                                    Export Excel
                                </button>
                                <button
                                    className="btn btn-primary m-2"
                                    disabled={!resultCount}
                                    onClick={this.handleExportCSV}
                                >
                                    Export CSV
                                </button>
                            </div>
                            <div className="d-flex mb-2">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="displayExecutiveSummary"
                                        onChange={() => {
                                            this.setState({
                                                displayExecutiveSummary: !displayExecutiveSummary
                                            });
                                        }}
                                        checked={displayExecutiveSummary}
                                    />
                                    <label
                                        className="custom-control-label"
                                        htmlFor="displayExecutiveSummary"
                                    >
                                        Display Executive Summary
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.props.loading || <Spinner />}
                <ReactTable
                    data={data}
                    headerClassName="table-header"
                    columns={this.getColumns()}
                    pageSize={pageSize}
                    resizable
                    filterable
                    className="-striped -highlight fix-scrollbar-size summary-table"
                    //loading={loading}
                    ref={this.reactTable}
                    defaultFilterMethod={filterCaseInsensitive}
                    onSortedChange={this.handleSortedChange}
                    onFilteredChange={this.onFilteredChange}
                    manual={false}
                    showPagination={false}
                    defaultSorted={[{
                        id: "storeNumber",
                        desc: false
                    }]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 240px)",
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    loading: state.summary.loading,
    summaryJobs: state.summary.summaryJobs,
    summaryList: state.summary.summaryList,
    summaryRanges: state.summary.summaryRanges,
});

const mapStateToDispatch = dispatch => ({
    fetchSummaryJobs: bindActionCreators(fetchSummaryJobs, dispatch),
    fetchSummary: bindActionCreators(fetchSummary, dispatch),
    fetchReportRanges: bindActionCreators(fetchReportRanges, dispatch),
    clearSummary: bindActionCreators(clearSummary, dispatch),
    fetchExportExcel: bindActionCreators(fetchExportExcel, dispatch),
    fetchExportCSV: bindActionCreators(fetchExportCSV, dispatch),
    updateReleaseAll: bindActionCreators(updateReleaseAll, dispatch),
    updateReleaseSingle: bindActionCreators(updateReleaseSingle, dispatch),
    updateDisplayChartToClient: bindActionCreators(updateDisplayChartToClient, dispatch),
    updateReviewed: bindActionCreators(updateReviewed, dispatch),
    updateReviewed2: bindActionCreators(updateReviewed2, dispatch),
    updateReleaseNotes: bindActionCreators(updateReleaseNotes, dispatch),
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SummaryMain);
